import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { RateLimitInterceptor } from './interceptors/rate-limit.interceptor';
import { SessionRetryInterceptor } from './interceptors/session-retry.interceptor';

@NgModule({
    imports: [CommonModule, HttpClientModule],
    providers: [
        // RateLimitInterceptor is a side-effect-only observer (latch +
        // rethrow) and only acts on 429+RATE_LIMIT_EXCEEDED. Order relative
        // to the other two is moot because neither SessionRetry (401-only)
        // nor Api (no error handling) touches 429 responses.
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RateLimitInterceptor,
            multi: true,
        },
        // SessionRetryInterceptor MUST be registered before ApiInterceptor so
        // that the replayed request flows back through ApiInterceptor and
        // picks up the freshly-minted X-PLG-Session header.
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SessionRetryInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
    ],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in AppModule only.');
        }
    }
}
